import { useRequest } from 'ahooks';
import { useAtomValue, useSetAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';

import { entryGame } from '@/api/game';
import { ACCESS_TOKEN_KEY, ACCESS_USERID_KEY } from '@/constant/config';
import { gamesListAtom, updateRecentlyGameAtom } from '@/jotai/game';
import { gameStore } from '@/stores/game';
import globalStore from '@/stores/store';
import Storage from '@/utils/Storage';

const useEntrygame = () => {
  const navigate = useNavigate();
  const updateRecentlyGame = useSetAtom(updateRecentlyGameAtom);
  const gamesList = useAtomValue(gamesListAtom);
  const { runAsync: runEntry } = useRequest(
    (pack: string | Record<string, any>) => {
      let gameitem;
      if (typeof pack === 'string') {
        gameitem = gamesList.find(item => item.pack === pack);
      } else {
        gameitem = pack;
      }
      if (!gameitem) {
        return Promise.reject();
      }
      const { room_list, company } = gameitem;
      const [{ pack: packName, level, pg_id }] = room_list;
      return entryGame({
        packname: packName,
        level,
        pgId: pg_id,
        pack,
        company
      });
    },
    {
      manual: true,
      onSuccess: (res, [pack]) => {
        let gameitem;
        if (typeof pack === 'string') {
          gameitem = gamesList.find(item => item.pack === pack);
        } else {
          gameitem = pack;
        }
        if (!gameitem) {
          return;
        }
        const { room_list, company } = gameitem;
        const [{ pack: packName, level, pg_id }] = room_list;
        const token = Storage.getAccess(ACCESS_TOKEN_KEY);
        const userId = Storage.getAccess(ACCESS_USERID_KEY);
        const isVipGame = /^game\d+$/.test(gameitem.pack) && parseInt(gameitem.pack.replace('game', '')) >= 100;
        const parts = res.url.split('/games/');
        const logoPath = parts[0] + '/games/logo/';
        let logo = window?.__SITE_CONFIG__?.productName?.toLocaleLowerCase() || '7usslot';
        if (window?.privateConfig?.code === 'fish') logo = '7usfish';

        Storage.set(
          'PLAY_GAME',
          res.url +
            '&gamekind=' +
            packName +
            '&userid=' +
            userId +
            '&token=' +
            token +
            '&score=' +
            globalStore.initialState.score +
            '&pg_id=' +
            (pg_id || 0) +
            `&isVipGame=${isVipGame}` +
            `&origin=${encodeURIComponent(window.location.origin)}` +
            (company === 'FISH' ? '&isFishGame=1' : '') +
            `&logo=${logoPath}${logo}` +
            `&isplaybgm=${Storage.getByUser('MUSIC_STATE', true)}`
        );
        updateRecentlyGame([gameitem]);
        navigate('/play');
        gameStore.entryGame();
      }
    }
  );
  return {
    runEntry
  };
};

export default useEntrygame;
